import { FilterRowProps } from "../../UtilitiesComponent/FilterRow";
import assest from "../../../json/assest";
// import Image from "next/image";
import React, { useState } from "react";
import styles from "../../../styles/pages/submithome.module.scss";
import styles1 from "../../../styles/components/SubmittedPageTable/submittedTable.module.scss";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../UtilitiesComponent/Pagination";
import AllPurchasedFilterModal from "../../FilterModal/AllPurchasedFilterModal";
import SubmittedApproveFilter from "../../AllFilterRow/SubmittedPageFilter/SubmittedApproveFilter";
import { useNavigate } from "react-router";
import SubmittedApprovedFilterModal from "../../FilterModal/SubmittedApprovedFilterModal ";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
  roleFinder,
} from "../../../lib/functions/utils.lib";
import PaginationTwo from "../../UtilitiesComponent/PaginationTwo";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import NoResultTwo from "../../NoResult/NoResultTwo";
import Filter from "../../Filter/Filter";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";

export default function SubmittedApproveTableTwo(props) {
  const {
    filterRowProps,
    datas,
    handlePageChange,
    filterRefetch,
    page,
    p,
    handleClearFilterModal,
    confirmed,
    filterActive,
    filtersReset,
    handleTriggreFetch,
    loading,
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };
  return (
    <Box
      className={`${styles.table_sec} ${styles.submitTable} ${styles1.submitTableApprove}`}
    >
      <Box className={styles.table_top}>
        <SubmittedApproveFilter
          {...filterRowProps}
          filterActive={filterActive}
          FilterModalComponent={SubmittedApprovedFilterModal}
          filterModalProps={{
            hideBottom: true,
            filterRefetch,
            handleClearFilterModal,
            p,
          }}
        />
      </Box>
      <Box className={`${styles.table_main} ${styles1.submitApproveTable}`}>
        {/* <PerfectScrollbar
          className={`${
            datas?.data.length > 0 ? styles.withHeight : styles.withoutHeight
          }`}
        > */}
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={styles1.visd}>VSID</TableCell>
                <TableCell className={styles1.acqui}>Acquisitor</TableCell>
                <TableCell className={styles1.thumb}>Thumbnail</TableCell>
                <TableCell className={styles1.title}>Title</TableCell>
                <TableCell className={styles1.submitter}>
                  Submitter Name
                </TableCell>
                <TableCell className={styles1.email}>Email Address</TableCell>
                <TableCell className={styles1.submission}>
                  Submission Date
                </TableCell>
                <TableCell className={styles1.approved}>Approved by</TableCell>
                <TableCell className={styles1.view}>View</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {datas?.data.map((row) => (
                <>
                  <TableRow key={row.VSID}>
                    <TableCell>
                      <Box className={styles.vsid_code}>
                        <p>
                          {row.id}
                          {/* <span className={styles.vsid_circ}></span> */}
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.acquisitor}>
                        {" "}
                        {row.user?.name} {row.user?.last_name}
                        <p className={styles.table_customer}>
                          {roleFinder(row.user?.role_id)}
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button onClick={() => onOpenTwo(row.id)}>
                        <figure className={styles.thumb_img}>
                          <img
                            className={styles.thumb_img}
                            src={concatHostAndImagePath(row.thumbnail)}
                          />
                        </figure>
                      </Button>
                    </TableCell>
                    <TableCell><Box className={styles.titleBox}>{row.title}</Box></TableCell>
                    <TableCell>
                      <Box className={styles.submittedName}>{row.first_name} {row.last_name}</Box>                      
                    </TableCell>
                    <TableCell>
                      {row.email}
                      {row.unreachable_submitter ? (
                        <p className={styles.red_email}>Unreachable Email</p>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell>
                      {getUtcDate(row.created_at)} <br />
                      {getUtcTime(row.created_at)}
                    </TableCell>
                    <TableCell
                      className={`${
                        !confirmed ? styles1.inquirerBoxActive : ""
                      }`}
                    >
                      <Box className={styles1.inquirerBox}>
                        {confirmed ? (
                          <>
                            {row.manager?.name}
                            <br /> <span>Manager</span> <br />
                            <strong>
                              {" "}
                              {row.video_meta.manager_updated_at
                                ? `${getUtcDateTime(
                                    row.video_meta.manager_updated_at
                                  )}`
                                : ""}
                            </strong>
                          </>
                        ) : (
                          <>Awaiting Confirmation</>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.table_view}>
                        <Button onClick={() => onOpen(row.id)}>
                          <img
                            src={assest.tableview}
                            width={16}
                            height={16}
                            alt=""
                          />
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow key={99} className={styles.blnkTd}>
                    <TableCell colSpan={9}>{""}</TableCell>
                  </TableRow>
                </>
              ))}
              <TableRow className={styles.paginationTble}>
                <TableCell colSpan={10} sx={{ border: "none !important" }}>
                  {datas?.data.length > 0 ? (
                    <>
                      {datas.data.length < datas.per_page &&
                      datas.last_page == 1 ? (
                        <>
                          <p className={styles.endList}>
                            End of list. We couldn't find more videos that match
                            your selected filter(s).
                          </p>
                        </>
                      ) : (
                        <>
                          <PaginationTwo
                            page={page}
                            count={datas?.last_page}
                            handleChange={handlePageChange}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* </PerfectScrollbar> */}
        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        {datas?.data.length > 0 ? (
          <></>
        ) : (
          <>
            {filterActive ? (
              <Filter resetFilters={filtersReset} />
            ) : (
              <>{!loading && <NoResultTwo heading="unreach" />}</>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
